<template>
  <section class="ppt-banner" data-buried="Banner">
    <h1 class="ppt-banner-title font-dt">
      有言PPT Speak<br />
      让PPT开口说话的AI数字人互动智能体
    </h1>
    <p class="ppt-banner-sub">
      上传PPT，仅需<span>2步操作</span>，有言自动生成可问答的3D数字人智能体，告别单向播放，知识真正活起来。
    </p>
    <div class="ppt-banner-buttons mt-[40px] mb-[100px]">
      <StartBtn class="!w-[330px]" text="创建我的数字人智能体" :handler="handler" />
    </div>
    <div class="video-wrapper">
      <div ref="videoContainer" class="banner-video relative z-[1]">
        <VideoPlayer
          class="ppt-video_cover"
          :autoplay="true"
          :muted="true"
          :enable-fullscreen="false"
          :controls="false"
          :poster="getFeUrl('/youyan-platform/chat-ppt/3.jpg?x-oss-process=image/format,webp')"
        />
        <ImmediateBtn class="absolute right-[64px] bottom-[103px] z-[100]" @click="onChatDemo" />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import VideoPlayer from '~/components/video-player/index.vue';
import StartBtn from '~/design/components/start-btn/index.vue';
import { getFeUrl } from '~/utils/url';
import ImmediateBtn from './immediate-btn.vue';

const props = defineProps<{
  handler: () => void;
}>();

const videoContainer = ref<HTMLElement>();

// const onHandler = () => {
//   location.href = `${location.origin}/editor/page/chat`;
// };

const onChatDemo = () => {
  window.open(
    `${location.origin}/editor/page/chat-demo/3907985/9fb9aff7f5cf480e8cd75664942373f3`,
    '_blank',
  );
};
</script>
<style lang="scss">
.ppt-video_cover {
  aspect-ratio: 16/9;
  border-radius: 12px 12px 0 0;
  width: auto;
  video {
    border-radius: 12px 12px 0 0;
    object-fit: contain;
  }
}
</style>
<style lang="scss" scoped>
.ppt-banner {
  padding-top: 163px;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.video-wrapper {
  width: 100%;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 488px;
    background: linear-gradient(to bottom, #ffffff 0%, #e8eaee 100%);
    z-index: 0;
  }
}
.banner-video {
  position: relative;
  max-width: clamp(1200px, 1200px + (100vw - 1600px) * 0.75, 1440px);
  margin: 0 auto;
  overflow: hidden;
  will-change: transform, border-radius;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  padding: 22px 16px;
  border-radius: 32px 32px 0 0;
  background: rgba(0, 0, 0, 1);
  border: 2px solid rgba(74, 85, 105, 1);

  // 大屏幕时固定尺寸并居中
  @media screen and (min-width: 2560px) {
    width: 2560px;
    // height: 544px;
  }

  &.is-scaling {
    z-index: 10;
  }

  &:deep(video) {
    object-fit: cover;
    border-radius: inherit;
    width: 100%;
    height: 100%;
    will-change: auto;
  }
}

button {
  border: none;
  line-height: 1;
  padding: 0;
  background-color: transparent;
  cursor: pointer;
}

.ppt-banner-title {
  font-size: 72px;
  font-weight: 400;
  text-align: center;
  line-height: 86px;
  margin: 0;
  color: var(--x-text-1);
}

.ppt-banner-sub {
  margin-top: 24px;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  color: var(--x-text-5);
  span {
    font-weight: 500;
    color: var(--x-text-1);
  }
}
</style>
